import React, { forwardRef, memo, useImperativeHandle, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'

const useStyles = makeStyles(theme => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #cecece',
      borderRadius: '4px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 1, 3)
   }
}))

const CustomModal = memo(
   forwardRef((props, ref) => {
      const { showModal = false, children } = props

      const classes = useStyles()
      const [open, setOpen] = useState(showModal)

      useImperativeHandle(ref, () => ({
         closeModal() {
            handleCloseModal()
         }
      }))

      const handleCloseModal = () => {
         setOpen(false)
      }

      return (
         <div>
            <Modal
               aria-labelledby="spring-modal-title"
               aria-describedby="spring-modal-description"
               className={classes.modal}
               open={open}
               onClose={handleCloseModal}
               closeAfterTransition
               BackdropComponent={Backdrop}
               BackdropProps={{
                  timeout: 500
               }}
            >
               <div className={classes.paper}>{children}</div>
            </Modal>
         </div>
      )
   })
)

export default CustomModal
